import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

import { getSignal } from '@app/adapters/abort'

export default {
  getCommunication(endpointParams = {}) {
    const companyId =
      endpointParams.companyId ||
      endpointParams.notifications.activeCompanyId ||
      Silverfin.jsonParams.company_id

    if (!companyId) {
      SfLog.info('getCommunication called with no company_id', {
        extra: {
          ...Silverfin.jsonParams,
        },
      })

      return
    }

    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      context_type: endpointParams.contextType,
      context_id: endpointParams.contextId,
      ledger_id: endpointParams.ledgerId,
      communication_item_type: endpointParams.communicationItemType,
      communication_item_id: endpointParams.communicationItemId,
      pulse_scope: endpointParams.pulseScope,
      company_notifications_scope: endpointParams.companyNotificationsScope,
    }
    const url = Silverfin.Routes.communications_path(params)

    return SFetch.jsonWithAlert(url, { signal: getSignal('communications') })
  },

  getMentionUsernames(endpointParams = {}) {
    const companyId =
      endpointParams.companyId || Silverfin.jsonParams.company_id

    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
    }

    const url = Silverfin.Routes.mentionable_usernames_path(params)

    return SFetch.jsonWithAlert(url, { signal: getSignal('communications') })
  },

  getTimelineData(endpointParams) {
    const params = {
      ...Silverfin.jsonParams,
      context_type: endpointParams.contextType,
      context_id: endpointParams.contextId,
      ledger_id: endpointParams.ledgerId,
    }
    const url = Silverfin.Routes.communication_timelines_path(params)

    return SFetch.json(url, { signal: getSignal('communications') })
  },
}
